import React from "react";
import { Form, Col, Row, Card } from "react-bootstrap";

import { CSR_CONTRIBUTION_OPTIONS } from "../../../constants/constants";
import { getFormattedDate, getFullName } from "../../../util/helpers";
import { getDeclarationPlace } from "../../../util/onBoardingDataFilters";
import useValidation from "../../../util/useValidation";
import "../../../styles/styles.css";

const CSRForm = ({ personalDetails, updatePersonalDetails }) => {
  const { handleOnBlurValidation, errors } = useValidation();
  const handleOnBlurInput = e => {
    handleOnBlurValidation(e);
  };
  const { declarationDate, declarationPlace } = personalDetails

  return (
    <Card>
      <Card.Header className="text-center">
        CSR Contribution Declaration
      </Card.Header>
      <Card.Body>
        <p>
          The Manager
          <br />
          Human Resources
          <br />
          CDK Global (India) Private Limited
        </p>
        <p>
          Sub: Authorization for payroll deduction towards Voluntary CSR
          Contribution
        </p>
        <p>Dear Sir,</p>
        <p>
          I understand that CDK Global (India) Private Limited supports social
          and charitable causes and that employees can contribute money in
          support of these causes.
        </p>
        <p>
          I hereby authorize CDK Global (India) Private Limited to deduct INR
          <Form.Group
            controlId="csrContribution"
            className="csr-contribution-amount"
          >
            <Form.Control
              as="select"
              class="mx-1"
              className="csr-contribution-selectable"
              isInvalid={errors.cSRContribution}
              name="cSRContribution"
              onBlur={handleOnBlurInput}
              onChange={({ target: { name, value } }) =>
                updatePersonalDetails(name, value)
              }
              required
              value={personalDetails.cSRContribution}
            >
              <option value="">Choose</option>
              {CSR_CONTRIBUTION_OPTIONS.map(csrOption => (
                <option value={csrOption.id}>{csrOption.amount}</option>
              ))}
            </Form.Control>
            {errors.cSRContribution && (
              <Form.Control.Feedback
                type="invalid"
                className="csr-invalid-entry"
              >
                {errors.cSRContribution.type === "required" &&
                  "CSR Contribution is required"}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          /- From my payroll every month as my voluntary contribution towards
          CSR activities that CDK supports. I understand that this is purely
          voluntary in nature and can be modified anytime by me.
        </p>
        <p>
          I further authorize the company to continue these deductions until
          further notice Sincerely
        </p>
        <Form.Group as={Row} controlId="signature">
          <Form.Label column sm={2}>
            Signature*
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              size="sm"
              required
              placeholder="Signature"
              type="text"
              name="signature"
              value={getFullName(personalDetails)}
              disabled
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="name">
          <Form.Label column sm={2}>
            Name*
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              size="sm"
              required
              placeholder="Name"
              type="text"
              name="name"
              value={getFullName(personalDetails)}
              disabled
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="date">
          <Form.Label column sm={2}>
            Date*
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              size="sm"
              required
              placeholder="Date"
              type="date"
              name="date"
              value={getFormattedDate(
                declarationDate,
                undefined,
                "YYYY-MM-DD"
              )}
              disabled
            />
          </Col>
        </Form.Group>
        <Form.Group as={Row} controlId="place">
          <Form.Label column sm={2}>
            Place*
          </Form.Label>
          <Col sm={4}>
            <Form.Control
              size="sm"
              required
              placeholder="Place"
              type="text"
              name="declarationPlace"
              value={
                getDeclarationPlace(declarationPlace)
              }
              disabled
            />
          </Col>
        </Form.Group>
        <h6>Note:</h6>
        <ul>
          <li>
            Employees can modify / change / stop their contributions by logging
            on to IKARE.
          </li>
          <li>
            A recurring minimum contribution of Rs. 100 with increments of Rs.
            100 each can be made upto a maximum of Rs. 2500 per month
          </li>
          <li>
            Contributions are used for supporting charities managed by United
            Way of Hyderabad and contributions made under the program qualify
            for 50% tax exemption under Section 80G of Income Tax Act.
          </li>
        </ul>
      </Card.Body>
    </Card>
  );
};

export default CSRForm;
